import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';

const useStyles = createUseStyles({
  bullet: {
    fontFamily: 'Helvetica, Arial, sans-serif',
    fontWeight: 400,
  },
});

export default function ObscureCardNumber(props) {
  const classes = useStyles();
  
  return (
    <>
      <span aria-hidden="true" className={classes.bullet}>•••• •••• •••• </span>
      {props.cardNumber.substring(props.cardNumber.length - 4)}
    </>
  );
}

ObscureCardNumber.propTypes = {
  cardNumber: PropTypes.string.isRequired,
};
